import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { Accordion } from 'src/components/accordion';
import FormInput from 'src/components/form-input';
import { IVlanItemWithVariable } from 'src/context/global/types';
import { hasVariable } from 'src/utils/wizard';
import { twMerge } from 'tailwind-merge';

interface WizardVlanTableProps {
  vlans: IVlanItemWithVariable[];
  vlanVariables: string[];
  onUpdateVlan: (
    vlanId: string,
    field: 'vlanId' | 'description',
    value: string,
  ) => void;
}

export default function WizardVlanTable({
  vlans,
  vlanVariables,
  onUpdateVlan,
}: WizardVlanTableProps) {
  return (
    <Accordion
      title="Vlans"
      subtitle={vlanVariables.length > 0 ? `(${vlanVariables.join(',')})` : ''}
      panelClassName="p-0"
      action={
        vlanVariables.length > 0 && (
          <CheckCircleIcon className="size-6 text-green-500" />
        )
      }
    >
      <table className="w-full divide-y divide-gray-200 rounded-b-md border border-gray-200 text-base text-gray-900">
        <thead>
          <tr className="bg-gray-100">
            <th className="border-r border-gray-200 p-1 text-center">
              Vlan ID
            </th>
            <th className="p-1 text-center">Vlan Description</th>
          </tr>
        </thead>
        <tbody>
          {vlans.map((vlan, index) => {
            const activeVlanId = hasVariable(vlan.vlanId.toString() || '');
            const activeDescription = hasVariable(vlan.description || '');
            return (
              <tr
                key={vlan.id}
                className="border-b border-gray-200 last:border-b-0 even:bg-gray-50/50"
              >
                <td className="border-r border-gray-200 p-1">
                  <FormInput
                    id={`wizard-vlan-id-${vlan.id}-${index}`}
                    className={twMerge([
                      activeVlanId && 'border-green-500 bg-green-500/50',
                    ])}
                    name={`wizard-vlan-id-${vlan.id}-${index}`}
                    value={vlan.vlanId}
                    onChange={(e) => {
                      onUpdateVlan(vlan.id, 'vlanId', e.target.value);
                    }}
                  />
                </td>
                <td className="p-1">
                  <FormInput
                    id={`wizard-vlan-description-${vlan.id}-${index}`}
                    className={twMerge([
                      activeDescription && 'border-green-500 bg-green-500/50',
                    ])}
                    name={`wizard-vlan-description-${vlan.id}-${index}`}
                    value={vlan.description}
                    onChange={(e) => {
                      onUpdateVlan(vlan.id, 'description', e.target.value);
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Accordion>
  );
}
